import NaeCenterColumn from './NaeCenterColumn'
import NaePageViewLayout from './NaePageViewLayout'
import NaePageWrapper from './NaePageWrapper'

export default { NaeCenterColumn, NaePageViewLayout, NaePageWrapper }
